const NAV = [
  { label: '今日热榜', href: '#hot' },
  { label: '最新热瓜', href: '#feed' },
  { label: '深扒专题', href: '#feature' },
  { label: '每周人气榜', href: '#rank' },
  { label: '圈内大事记', href: '#timeline' },
  { label: '常见问题', href: '#faq' },
];

const ABOUT_LINKS = [
  { label: '关于吃瓜八卦', href: '#about' },
  { label: '常见问题', href: '#faq' },
  { label: '爆料投稿', href: '#about' },
  { label: '回到顶部', href: '#top' },
];

const CHANNELS = ['演员', '歌手', '爱豆', '综艺', '电影', '幕后'];

const CONTACT = 'hi@chigua.example.com';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
        {/* brand */}
        <div className="sm:col-span-2 lg:col-span-1">
          <a href="#top" className="flex items-center gap-2.5" aria-label="吃瓜八卦首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-primary-700">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold text-background-50">吃瓜八卦</span>
              <span className="font-label text-[11px] text-background-100/60">
                明星 · 演员 · 歌手 · 爱豆
              </span>
            </span>
          </a>
          <p className="mt-5 text-sm leading-relaxed text-background-100/70">
            娱乐明星八卦内容门户，汇总明星、演员、歌手、爱豆最新动态与幕后故事，做你追星路上的信息整理员。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {['weibo', 'xiaohongshu', 'youtube'].map((n) => (
              <span
                key={n}
                aria-hidden="true"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/15 text-background-100/70"
              >
                <i className={`ri-${n}-line text-base`}></i>
              </span>
            ))}
          </div>
        </div>

        {/* content nav */}
        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">内容导航</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {NAV.map((n) => (
              <li key={n.href + n.label}>
                <a
                  href={n.href}
                  className="text-sm text-background-100/70 transition-colors hover:text-secondary-300"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* hot channels */}
        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">热门栏目</h4>
          <ul className="mt-4 flex flex-wrap gap-2">
            {CHANNELS.map((c) => (
              <li key={c}>
                <a
                  href="#feed"
                  className="inline-flex whitespace-nowrap rounded-full border border-background-50/15 px-3.5 py-1.5 text-xs text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-200"
                >
                  {c}
                </a>
              </li>
            ))}
          </ul>
          <h4 className="mt-6 font-heading text-sm font-bold text-background-50">快捷入口</h4>
          <ul className="mt-4 flex flex-col gap-2.5">
            {ABOUT_LINKS.map((n) => (
              <li key={n.label}>
                <a
                  href={n.href}
                  className="text-sm text-background-100/70 transition-colors hover:text-secondary-300"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* contact */}
        <div>
          <h4 className="font-heading text-sm font-bold text-background-50">联系我们</h4>
          <p className="mt-4 text-sm leading-relaxed text-background-100/70">
            爆料投稿、素材提供或内容建议，欢迎来信，我们将认真查看每一条线索。
          </p>
          <a
            href={`mailto:${CONTACT}`}
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/5 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-mail-send-line text-accent-300"></i>
            {CONTACT}
          </a>
          <div className="mt-5 rounded-2xl bg-background-50/5 p-4 text-xs leading-relaxed text-background-100/60">
            <strong className="font-semibold text-background-100/80">更新说明：</strong>
            内容每天滚动更新，以公开信源为准；涉未证实信息均作标注并持续跟进。转载需授权。
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex flex-col gap-2 px-4 py-5 text-xs text-background-100/55 sm:flex-row sm:items-center sm:justify-between md:px-6 lg:px-10">
          <p>© 2024 吃瓜八卦 · 仅供娱乐分享与信息整理，理性吃瓜，快乐追星。</p>
          <p className="whitespace-nowrap">信源以公开信息为准 · 有反转必跟进</p>
        </div>
      </div>
    </footer>
  );
}